var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcArrow = function SvgIcArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303242",
    d: "M10.732 14c-.77 1.333-2.694 1.333-3.464 0L1.206 3.5c-.77-1.333.192-3 1.732-3h12.124c1.54 0 2.502 1.667 1.732 3z"
  })));
};
export default SvgIcArrow;